import '../App.css'
import  './vision.css';
import iconSecton from '../img/icon-section.png';
import logo_stb from '../img/logo-stb-blue.png'
import About from './about';

function Vision() {
    return (
        <div className="vision">
            <section id="vision">
                <img src={iconSecton} alt="icon-section" className='icon-section' />
                <h1>Vision</h1>
            </section>
            <div className='vision-section'>
                <div className="vision-text">
                    <h1>科学大生に第三の選択肢を</h1>
                    <h3 className='vision-text-detail'>
                         Science Tokyo Bizは、科学大生の視野が広がる場です。勉強会やプロジェクト、座談会などを通じて、スタートアップや起業の楽しさや難しさをリアルに体感できます。現役の学生起業家や若手OBが多数参加し、互いに支え合いながら科学大を盛り上げています。実践的な情報交換を通して、一歩を踏み出しましょう。
                    </h3>
                </div>

                <div className="vision-image">
                    <img src={logo_stb} alt="icon-section" />
                </div>
            </div>
            <About />
        </div>
    );
}
export default Vision;